<template>
  <div>
    <PageHeaderLayout>
      <div class="main-page-content">
        <!-- 页面标题区域 -->
        <div class="page-title-section">
          <div class="title-content">
            <h1 class="page-title">
              <i class="el-icon-tickets"></i>
              优惠券规则
            </h1>
            <p class="page-subtitle">管理注册发放的优惠券规则，支持满减与折扣两种类型</p>
          </div>
        </div>

        <!-- 操作面板 -->
        <div class="action-card">
          <div class="action-buttons">
            <el-button
              type="primary"
              size="medium"
              icon="el-icon-plus"
              class="add-btn"
              @click="addButton()">
              添加优惠券规则
            </el-button>
          </div>
        </div>

        <!-- 搜索筛选卡片 -->
        <div class="search-card">
          <div class="search-header">
            <h3 class="search-title">
              <i class="el-icon-search"></i>
              搜索筛选
            </h3>
          </div>
          <el-form size="medium" :inline="true" :model="searchCondition" class="search-form">
            <el-form-item label="券名">
              <el-input
                v-model="searchCondition.name"
                placeholder="输入券名搜索"
                prefix-icon="el-icon-search"
                clearable>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton" class="search-btn">
                <i class="el-icon-search"></i>
                查询
              </el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 表格卡片 -->
        <div class="table-card">
          <ApeTable ref="apeTable" :data="list" :loading="loadingStaus" :pagingData="pagingData" @switchPaging="switchPaging" highlight-current-row>
            <el-table-column width="80" label="序号">
              <template slot-scope="scope">
                <span class="row-number">{{offset+scope.$index+1}}</span>
              </template>
            </el-table-column>
            <el-table-column label="券名" min-width="160">
              <template slot-scope="scope">
                <strong class="coupon-name">{{scope.row.name}}</strong>
              </template>
            </el-table-column>
            <el-table-column label="类型" width="90" align="center">
              <template slot-scope="scope">
                <el-tag :type="scope.row.type=='1' ? 'primary' : 'success'" size="small">
                  {{ scope.row.type=='1' ? '满减' : '折扣' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="门槛/面额" min-width="150">
              <template slot-scope="scope">
                <span v-if="scope.row.type=='1'">满 {{scope.row.threshold}} 减 {{scope.row.amount}}</span>
                <span v-else>减 {{scope.row.percent}}%</span>
              </template>
            </el-table-column>
            <el-table-column label="有效期" width="90" align="center">
              <template slot-scope="scope">
                {{scope.row.valid_days}} 天
              </template>
            </el-table-column>
            <el-table-column label="注册发放" width="100" align="center">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.auto_issue"
                  :active-value="'1'"
                  :inactive-value="'0'"
                  @change="changeField(scope.row, 'auto_issue')">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="状态" width="90" align="center">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.status"
                  :active-value="'1'"
                  :inactive-value="'0'"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  @change="changeField(scope.row, 'status')">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="备注" min-width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                {{scope.row.remark || '-'}}
              </template>
            </el-table-column>
            <el-table-column v-if="buttonType=='icon'" width="140" label="操作" align="center">
              <template slot-scope="scope">
                <el-tooltip effect="dark" content="编辑" placement="top-start">
                  <el-button
                    size="mini"
                    type="primary"
                    icon="el-icon-edit"
                    class="action-btn edit-btn"
                    @click="editButton(scope.row.id)">
                  </el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="删除" placement="top-start">
                  <el-popconfirm title="确定删除这条优惠券规则吗？" @confirm="deleteButton(scope.row.id)">
                    <el-button slot="reference" size="mini" type="danger" icon="el-icon-delete" class="action-btn"></el-button>
                  </el-popconfirm>
                </el-tooltip>
              </template>
            </el-table-column>
          </ApeTable>
        </div>
      </div>
    </PageHeaderLayout>

    <ModalDialog :dialogData="dialogData" @dialogConfirm="handleConfirm" @dialogClose="dialogClose">
      <template slot="content">
        <el-form :model="formData" :rules="rules" ref="dataForm" label-position="right" label-width="100px">
          <el-form-item label="券名" prop="name">
            <el-input v-model="formData.name" placeholder="如：满150减50"></el-input>
          </el-form-item>
          <el-form-item label="类型" prop="type">
            <el-radio-group v-model="formData.type">
              <el-radio label="1">满减</el-radio>
              <el-radio label="2">折扣</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="formData.type=='1'">
            <el-form-item label="使用门槛" prop="threshold">
              <el-input-number v-model="formData.threshold" :min="0" :precision="2" :step="10"></el-input-number>
              <span class="form-tip">订单满该金额可用（美元）</span>
            </el-form-item>
            <el-form-item label="抵扣金额" prop="amount">
              <el-input-number v-model="formData.amount" :min="0.01" :precision="2" :step="5"></el-input-number>
              <span class="form-tip">减去的金额（美元）</span>
            </el-form-item>
          </template>
          <el-form-item v-if="formData.type=='2'" label="折扣百分比" prop="percent">
            <el-input-number v-model="formData.percent" :min="0.01" :max="99" :precision="2" :step="5"></el-input-number>
            <span class="form-tip">10 表示减 10%（即 9 折）</span>
          </el-form-item>
          <el-form-item label="有效期" prop="valid_days">
            <el-input-number v-model="formData.valid_days" :min="1" :precision="0" :step="30"></el-input-number>
            <span class="form-tip">天（自发放时刻起算）</span>
          </el-form-item>
          <el-form-item label="注册发放" prop="auto_issue">
            <el-switch
              v-model="formData.auto_issue"
              :active-value="'1'"
              :inactive-value="'0'">
            </el-switch>
            <span class="form-tip">勾选后，用户提交补充信息表单时自动发放此券</span>
          </el-form-item>
          <el-form-item label="启用" prop="status">
            <el-switch
              v-model="formData.status"
              :active-value="'1'"
              :inactive-value="'0'"
              active-color="#13ce66"
              inactive-color="#ff4949">
            </el-switch>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="formData.remark" type="textarea" :rows="2"></el-input>
          </el-form-item>
        </el-form>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import ModalDialog from '@/components/ModalDialog'
import { mapGetters } from 'vuex'

const END_POINT = '/service/ola_app_coupon_rule'

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    ModalDialog
  },
  data() {
    return {
      searchCondition: {
        name: '',
        current_page: 1,
        page_size: 20,
        query: '',
        params: []
      },
      loadingStaus: true,
      list: [],
      pagingData: {
        is_show: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        page_size: 20,
        total: 0
      },
      offset: 0,
      formData: {},
      rules: {
        name: [{ required: true, message: '券名必填', trigger: 'blur' }],
        type: [{ required: true, message: '类型必选', trigger: 'change' }],
        valid_days: [{ required: true, message: '有效期必填', trigger: 'change' }]
      },
      dialogData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        title: '添加优惠券规则',
        width_height: '620px'
      }
    }
  },
  computed: {
    ...mapGetters(['buttonType'])
  },
  methods: {
    searchButton() {
      this.initList()
    },
    async switchPaging() {
      this.initList()
    },
    addButton() {
      this.formData = {
        id: 0,
        type: '1',
        threshold: 0,
        amount: 0,
        percent: 0,
        valid_days: 365,
        auto_issue: '1',
        status: '1',
        remark: ''
      }
      this.dialogData.visible = true
      this.dialogData.title = '添加优惠券规则'
      this.dialogData.loading = false
    },
    async editButton(id) {
      this.dialogData.loading_text = '玩命加载中……'
      this.dialogData.visible = true
      this.dialogData.title = '编辑优惠券规则'
      let res = await this.$api.post(END_POINT + '/detail', { id: id })
      if (this.$apiSuccess(res)) {
        this.formData = res.data.detail
      }
      this.dialogData.loading = false
    },
    async changeField(row, field) {
      let data = { id: row.id }
      data[field] = row[field]
      let res = await this.$api.post(END_POINT + '/update', data)
      if (this.$apiSuccess(res)) {
        this.$message.success('已更新')
      } else {
        this.initList()
      }
    },
    async deleteButton(id) {
      let res = await this.$api.post(END_POINT + '/delete', { id: id })
      if (this.$apiSuccess(res)) {
        this.$message.success('删除成功')
        this.initList()
      }
    },
    handleConfirm() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.formSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    dialogClose() {
      this.initFormData()
    },
    initFormData() {
      this.$nextTick(() => {
        this.dialogData.visible = false
        this.dialogData.loading = true
        this.$refs['dataForm'].resetFields()
      })
    },
    async formSubmit() {
      let url = END_POINT + '/create'
      if (this.formData.id && this.formData.id !== 0) {
        url = END_POINT + '/update'
      }
      let res = await this.$api.post(url, this.formData)
      if (this.$apiSuccess(res)) {
        this.$message.success('保存成功!')
        this.initList()
      }
      this.initFormData()
    },
    async initList() {
      this.loadingStaus = true
      this.searchCondition.params = []
      this.searchCondition.query = ''
      let pagingInfo = this.$refs['apeTable'].getPagingInfo()
      Object.assign(this.searchCondition, pagingInfo)
      if (this.searchCondition.name != '') {
        this.searchCondition.query = 'instr(name,?)'
        this.searchCondition.params.push(this.searchCondition.name)
      }
      let res = await this.$api.post(END_POINT + '/list', this.searchCondition)
      if (this.$apiSuccess(res)) {
        this.list = res.data.list
        this.pagingData.total = res.data.page.total
      }
      this.loadingStaus = false
    }
  },
  mounted() {
    this.initList()
  }
}
</script>

<style lang="stylus" scoped>
  .main-page-content
    padding 24px
    min-height calc(100vh - 84px)
    background-color #f5f7fa

  // 页面标题区域
  .page-title-section
    background linear-gradient(135deg, #667eea 0%, #764ba2 100%)
    border-radius 12px
    padding 32px
    margin-bottom 24px
    color white
    box-shadow 0 8px 32px rgba(102, 126, 234, 0.15)

  .title-content
    text-align center

  .page-title
    font-size 32px
    font-weight 600
    margin 0 0 8px 0
    display flex
    align-items center
    justify-content center
    gap 12px

    i
      font-size 36px

  .page-subtitle
    font-size 16px
    opacity 0.9
    margin 0
    line-height 1.5

  // 操作面板
  .action-card
    background white
    border-radius 12px
    padding 20px 24px
    margin-bottom 24px
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
    border 1px solid #e8ecf4

  .action-buttons
    display flex
    gap 12px
    align-items center

  .add-btn
    background linear-gradient(45deg, #667eea, #764ba2)
    border none
    border-radius 8px
    padding 10px 20px
    font-weight 500
    transition all 0.3s ease

    &:hover
      transform translateY(-2px)
      box-shadow 0 8px 25px rgba(102, 126, 234, 0.3)

  // 搜索卡片
  .search-card
    background white
    border-radius 12px
    padding 24px
    margin-bottom 24px
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
    border 1px solid #e8ecf4

  .search-header
    margin-bottom 20px
    padding-bottom 12px
    border-bottom 2px solid #f0f2f5

  .search-title
    color #1f2937
    font-size 18px
    font-weight 600
    margin 0
    display flex
    align-items center
    gap 8px

  .search-form
    /deep/ .el-form-item
      margin-bottom 16px

    /deep/ .el-form-item__label
      color #374151
      font-weight 500

    /deep/ .el-input__inner
      border-radius 8px
      border 1px solid #d1d5db
      transition all 0.3s ease

      &:focus
        border-color #667eea
        box-shadow 0 0 0 3px rgba(102, 126, 234, 0.1)

    /deep/ .el-select
      width 180px

  .search-btn
    background linear-gradient(45deg, #667eea, #764ba2)
    border none
    border-radius 8px
    padding 12px 24px
    font-weight 500
    transition all 0.3s ease

    &:hover
      transform translateY(-2px)
      box-shadow 0 8px 25px rgba(102, 126, 234, 0.3)

  // 表格卡片
  .table-card
    background white
    border-radius 12px
    padding 24px
    box-shadow 0 4px 20px rgba(0, 0, 0, 0.08)
    border 1px solid #e8ecf4

  // 序号样式
  .row-number
    font-weight 600
    color #667eea
    background #f0f4ff
    padding 4px 8px
    border-radius 4px
    font-size 12px

  .coupon-name
    color #1f2937

  // 操作按钮
  .action-btn
    margin-left 6px
    border-radius 6px
    padding 6px
    transition all 0.3s ease

    &:hover
      transform translateY(-1px)

    &.edit-btn
      background linear-gradient(45deg, #fbbf24, #f59e0b)
      border none
      color white

      &:hover
        box-shadow 0 4px 15px rgba(251, 191, 36, 0.4)

  .form-tip
    margin-left 8px
    color #909399
    font-size 12px

  // 表格样式优化
  /deep/ .el-table
    border-radius 8px
    overflow hidden

    th
      background linear-gradient(45deg, #f8fafc, #f1f5f9)
      color #374151
      font-weight 600
      border-bottom 2px solid #e5e7eb

    td
      border-bottom 1px solid #f3f4f6

    tr:hover td
      background-color #f8fafc

  /deep/ .el-pagination
    margin-top 24px
    display flex
    justify-content center

  // 响应式设计
  @media (max-width: 768px)
    .main-page-content
      padding 16px

    .page-title-section
      padding 24px 20px

    .page-title
      font-size 24px

    .action-card, .search-card, .table-card
      padding 16px
</style>
